import React, {useEffect, useState} from "react";
import apiClient from "../axios/axiosInterceptor";
import TTSServiceProviderSearch from "./TTSServiceProviderSearch";
import '../modal.scss';
import TTSServiceProviderCreate from "./TTSServiceProviderCreate";
import TTSServiceProviderTable from "./TTSServiceProviderTable";
import {Slide, toast} from "react-toastify";

function TTSServiceProviders() {
    const [providers, setProviders] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editingProvider, setEditingProvider] = useState(null);

    const fetchProviders = async (name) => {
        const baseUrl = `/ttsServiceProviders`;

        try {
            const response = await apiClient.get(baseUrl);
            if (!name) {
                setProviders(response.data.list);
                return;
            }
            const filteredProviders = response.data.list.filter(provider =>
                provider.name.toLowerCase().includes(name.toLowerCase())
            );
            setProviders(filteredProviders);
        } catch (error) {
            console.error('Error fetching providers:', error);
        }
    };

    useEffect(() => {
        fetchProviders();
    }, []);

    const search = async (name) => {
        await fetchProviders(name);
    };

    const handleCreate = () => {
        setEditingProvider(null);
        setShowModal(true);
    };

    const handleEdit = (provider) => {
        setEditingProvider(provider);
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        const url = `/ttsServiceProviders/${id}`;

        try {
            await apiClient.delete(url);
            await fetchProviders();
        } catch (error) {
            console.error('Error deleting provider:', error);
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleSubmitModal = async (providerData) => {
        const url = editingProvider ?
            `/ttsServiceProviders/${editingProvider.id}` :
            `/ttsServiceProviders`;

        try {
            if (editingProvider) {
                await apiClient.patch(url, providerData);
                toast.success('TTS Service Provider updated!', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: false,
                    theme: "dark",
                    transition: Slide,
                });
            } else {
                await apiClient.post(url, providerData);
                toast.success('TTS Service Provider created!', {
                    position: "top-right",
                    autoClose: 3000,
                    closeOnClick: false,
                    theme: "dark",
                    transition: Slide,
                });
            }
            setShowModal(false);
            await fetchProviders();
        } catch (error) {
            console.error('Error saving provider:', error);
        }
    };

    return (
        <div className="mainBody">
            <TTSServiceProviderSearch onSearch={search} onCreate={handleCreate}/>
            <TTSServiceProviderTable providers={providers} onEdit={handleEdit} onDelete={handleDelete}/>
            {showModal && <TTSServiceProviderCreate provider={editingProvider} onClose={handleCloseModal}
                                                    onSubmit={handleSubmitModal}/>}
        </div>
    );
}

export default TTSServiceProviders;
